import {DocumentDetails} from './document-details.model';
import {JsonProperty} from '../utilities/utils/json-property.decorator';
export class DocumentForm {
  identifier: string = "";
  saveId: number;

  @JsonProperty({name: 'documents', clazz: DocumentDetails})
  documents: DocumentDetails[] = [];
}
